import { useEffect, useState } from 'react';
import { CheckCircleOutlined, EnvironmentOutlined, ExclamationCircleOutlined, PhoneFilled, PhoneOutlined, StarOutlined } from '@ant-design/icons';
import { Avatar, Button, Card, Carousel, Col, Divider, Input, Layout, Rate, Row, Skeleton, Space, Tag, Typography, message } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Get from '../services/Get';
import LandingFooter from '../components/layout/Footer';
import LandingHeader from '../components/layout/Header';
import Post from '../services/Post';
import axios from 'axios';

const { Title, Text } = Typography;
const { TextArea } = Input;

const BusinessDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // const queryParams = new URLSearchParams(location.search);
    // const business = queryParams.get("business");
    const { business } = useParams();

    const [rating, setRating] = useState(0);
    const [review, setReview] = useState("");
    const [businessDetails, setBusinessDetails] = useState(null);
    const [url, setUrl] = useState();
    const [loading, setLoading] = useState(true);
    const [ipAddress, setIpAddress] = useState();

    const getData = async () => {
        console.log(business);

        setLoading(true);
        try {
            const res = await Get.ListingBySlug(business);
            console.log(res);

            // Get user's IP
            const ipRes = await axios.get("https://api.ipify.org/?format=json");
            console.log(ipRes.data);
            const ip = ipRes.data.ip;
            setIpAddress(ip);

            // Add visitor
            await addVisitor(ip, res.data);

            setBusinessDetails(res.data);
            setUrl(res.url);
        } catch (err) {
            console.error("Error fetching data:", err);
        } finally {
            setLoading(false);
        }
    };

    const addVisitor = async (ip, data) => {
        const user = localStorage.getItem("user");
        let requestData = {
            listing_id: data.id,
            ip_address: ip
        };

        if (user) {
            const parsedUser = JSON.parse(user); // Parse user from localStorage
            requestData.user_id = parsedUser.id;
        }

        try {
            const res = await Post.AddVisitor(requestData);
            console.log("Visitor added:", res);
        } catch (err) {
            console.error("Error adding visitor:", err);
        }
    };

    const submitRating = () => {
        setLoading(true);
        Post.Rating({
            listing_id: businessDetails.id,
            rating: rating,
            review: review
        }).then((res) => {
            console.log(res);
            message.success('Review added successfully!');
            getData();
        }).catch((err) => {
            console.error(err);
            navigate('/sign-in', { state: { prevUrl: location.pathname } });
        }).finally(() => {
            setRating(0);
            setReview("");
            setLoading(false);
        })
    }

    const onCallClicked = (mobile) => {
        Post.VistorCallClicked({
            listing_id: businessDetails.id,
            ip_address: ipAddress
        }).then((res) => {
            console.log('res ===', res);
            window.location.href = `tel:${mobile}`;
        })
    }

    useEffect(() => {
        if (business) getData();
    }, [business]);

    return (
        <div>
            <Layout>
                <LandingHeader />
                <Row justify={'center'}>
                    <Col xs={24} md={14}>
                        <Row gutter={[16, 16]} style={{ padding: "20px" }}>
                            <Col span={24}>
                                <Card>
                                    {loading ? (
                                        <Skeleton avatar paragraph={{ rows: 2 }} />
                                    ) : (
                                        <Row align="middle" gutter={16}>
                                            <Col>
                                                <Avatar size={100} src={url + '/' + businessDetails.logo} />
                                            </Col>
                                            <Col>
                                                <Title level={3}>{businessDetails.business_name}</Title>
                                                <Text strong>{businessDetails.discount}</Text>
                                                <br />
                                                <Text type="secondary">{businessDetails.established} in Business</Text>
                                                <div>
                                                    <Tag color="green">{businessDetails.avg} ★</Tag>
                                                    <Text>({businessDetails?.rating?.length} Ratings)</Text>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                </Card>
                            </Col>

                            {
                                (!loading && businessDetails.images.length > 0) && (
                                    <Col className="mb-24" xs={24}>
                                        <Card bordered={false} className="criclebox h-full">
                                            {loading ? (
                                                <Space className="carousel-slide">
                                                    <Skeleton.Image active={true} className="carousel-image" />
                                                </Space>
                                            ) : (
                                                <Carousel autoplay>
                                                    {businessDetails.images.map((image, index) => (
                                                        <div key={index} className="carousel-slide">
                                                            <img src={'https://manage.rebatedekho.com/uploads/listing_photos/' + image.image} alt={`Slide ${index}`} className="carousel-image" />
                                                        </div>
                                                    ))}
                                                </Carousel>
                                            )}
                                        </Card>
                                    </Col>
                                )
                            }

                            <Col span={24}>
                                <Card>
                                    <Title level={5}>Contact Details</Title>
                                    {loading ? <Skeleton paragraph={{ rows: 2 }} /> : (
                                        <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Text><Text strong>Name: </Text>{businessDetails.contact_name}</Text>
                                            {/* <Text><PhoneOutlined /> {businessDetails.contact_no}</Text> */}
                                            <Button
                                                type="primary"
                                                icon={<PhoneFilled />}
                                                onClick={() => onCallClicked(businessDetails.contact_no)}
                                                className="form-btn"
                                                style={{
                                                    fontSize: "14px",
                                                }}
                                            >
                                                Call
                                            </Button>
                                        </Row>
                                    )}
                                </Card>
                            </Col>

                            <Col span={24}>
                                <Card>
                                    <Title level={5}>Address</Title>
                                    {loading ? <Skeleton paragraph={{ rows: 1 }} /> : (
                                        <Text><EnvironmentOutlined /> {businessDetails.address}, {businessDetails.city}, {businessDetails.pincode}</Text>
                                    )}
                                </Card>
                            </Col>

                            <Col span={24}>
                                <Card>
                                    <Title level={5}>About Us</Title>
                                    {loading ? <Skeleton paragraph={{ rows: 3 }} /> : <Text>{businessDetails.description}</Text>}
                                </Card>
                            </Col>

                            {businessDetails?.services?.length > 0 && (
                                <Col span={24}>
                                    <Card>
                                        <Title level={5}>Our Services</Title>
                                        {loading ? <Skeleton paragraph={{ rows: 1 }} /> : (
                                            businessDetails.services.map((d, i) => (
                                                <Tag color="blue" key={i}>{d.service.service}</Tag>
                                            ))
                                        )}
                                    </Card>
                                </Col>
                            )}

                            <Col span={24}>
                                <Card>
                                    <Title level={5}>Reviews & Ratings</Title>
                                    {loading ? <Skeleton paragraph={{ rows: 2 }} /> : (
                                        <>
                                            <Tag color="green">{businessDetails.avg} ★</Tag>
                                            <Text>{businessDetails.rating.length} Ratings</Text>
                                            <Divider />
                                            {businessDetails.rating.map((d, i) => (
                                                <Card key={i} style={{ marginBottom: "10px" }}>
                                                    <Row justify="space-between">
                                                        <Col>
                                                            <Title level={5}>{d.user.name}</Title>
                                                            <Tag color='green'>{d.rating} ★</Tag>
                                                        </Col>
                                                        <Col>
                                                            {/* <Text type="secondary">{new Date(d.created_at).toLocaleString()}</Text> */}
                                                            <Text type="secondary">{d.submitted}</Text>
                                                        </Col>
                                                    </Row>
                                                    <Text>{d.review}</Text>
                                                </Card>
                                            ))}
                                        </>
                                    )}
                                </Card>
                            </Col>

                            <Col span={24}>
                                <Card>
                                    <Title level={5}>Add Your Review</Title>
                                    <Rate onChange={setRating} value={rating} />
                                    <TextArea
                                        rows={4}
                                        placeholder="Write your review..."
                                        value={review}
                                        onChange={(e) => setReview(e.target.value)}
                                        style={{ marginTop: 10 }}
                                    />
                                    <Button
                                        type="primary"
                                        icon={<StarOutlined />}
                                        onClick={submitRating}
                                        style={{ marginTop: 20, backgroundColor: '#a6cc43', borderColor: '#a6cc43' }}
                                    >
                                        Submit Review
                                    </Button>
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <LandingFooter />
            </Layout>
        </div>
    );
};

export default BusinessDetails;
